import { Component } from 'react'

const getConnection = () => {
    return navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection;
}

class Network extends Component {
    constructor() {
        super();
        this.state = {
            connection: getConnection(),
            isOnline: !!getConnection().rtt
        }
    }

    getConnection = () => {
        return navigator.connection ||
            navigator.mozConnection ||
            navigator.webkitConnection;
    }

    updateStatus = () => {
        this.setState({
            connection: this.getConnection(),
            isOnline: !!this.getConnection().rtt
        })
    }
    
    componentDidMount() {
        this.state.connection.addEventListener('change', this.updateStatus);
    }

    componentWillUnmount() {
        this.state.connection.removeEventListener('change', this.updateStatus);
    }

    render() {
        const { isOnline, connection } = this.state
        return (
            <div className={
                `bg-danger network-notification ${ 
                    isOnline 
                        ? connection.effectiveType !== '4g'
                            ? 'active' 
                            : '' 
                        : 'active' 
            }`}>
                <i className='ti-alert'></i>&nbsp;&nbsp;{ 
                    isOnline 
                        ? connection.effectiveType !== '4g'
                            ? 'Slow Connection Detected'
                            : '' 
                        : 'No Internet Connection. Please contact UPT Jaringan' 
                }
            </div>
        )
    }
}

export default Network